import { render, staticRenderFns } from "./ModalAddCost.vue?vue&type=template&id=ad4908c0&scoped=true&"
import script from "./ModalAddCost.vue?vue&type=script&lang=js&"
export * from "./ModalAddCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4908c0",
  null
  
)

export default component.exports